export const NEW_POST_REQUEST = "NEW_POST_REQUEST";
export const NEW_POST_SUCCESS = "NEW_POST_SUCCESS";
export const NEW_POST_RESET = "NEW_POST_RESET";
export const NEW_POST_FAIL = "NEW_POST_FAIL";

export const POST_FOLLOWING_REQUEST = "POST_FOLLOWING_REQUEST";
export const POST_FOLLOWING_SUCCESS = "POST_FOLLOWING_SUCCESS";
export const POST_FOLLOWING_RESET = "POST_FOLLOWING_RESET";
export const POST_FOLLOWING_FAIL = "POST_FOLLOWING_FAIL";

export const LIKE_UNLIKE_POST_REQUEST = "LIKE_UNLIKE_POST_REQUEST";
export const LIKE_UNLIKE_POST_SUCCESS = "LIKE_UNLIKE_POST_SUCCESS";
export const LIKE_UNLIKE_POST_RESET = "LIKE_UNLIKE_POST_RESET";
export const LIKE_UNLIKE_POST_FAIL = "LIKE_UNLIKE_POST_FAIL";

export const NEW_COMMENT_REQUEST = "NEW_COMMENT_REQUEST";
export const NEW_COMMENT_SUCCESS = "NEW_COMMENT_SUCCESS";
export const NEW_COMMENT_RESET = "NEW_COMMENT_RESET";
export const NEW_COMMENT_FAIL = "NEW_COMMENT_FAIL";

export const SAVE_UNSAVE_POST_REQUEST = "SAVE_UNSAVE_POST_REQUEST";
export const SAVE_UNSAVE_POST_SUCCESS = "SAVE_UNSAVE_POST_SUCCESS";
export const SAVE_UNSAVE_POST_RESET = "SAVE_UNSAVE_POST_RESET";
export const SAVE_UNSAVE_POST_FAIL = "SAVE_UNSAVE_POST_FAIL";

export const DELETE_POST_REQUEST = "DELETE_POST_REQUEST";
export const DELETE_POST_SUCCESS = "DELETE_POST_SUCCESS";
export const DELETE_POST_RESET = "DELETE_POST_RESET";
export const DELETE_POST_FAIL = "DELETE_POST_FAIL";

export const POST_DETAILS_REQUEST = "POST_DETAILS_REQUEST";
export const POST_DETAILS_SUCCESS = "POST_DETAILS_SUCCESS";
export const POST_DETAILS_RESET = "POST_DETAILS_RESET";
export const POST_DETAILS_FAIL = "POST_DETAILS_FAIL";

export const CLEAR_ERRORS = "CLEAR_ERRORS";